import { IState } from '../../../../../store/types';
import { connect } from 'react-redux';
import { PhrasePopup } from '../components/PhrasePopup';
import { IPhrasePopupEvents, IPhrasePopupFields } from '../components/types';
import { PhrasePopupEvents } from './events';
import { PhraseListSelectors } from '../../../../../store/phrase-list/selectors';
import { IPhrasePopupHOCProps } from './types';
import { getMainLayoutPhrasesColumn } from '../../../../../store/general/selectors';
import { EPhrasesColumnType } from '../../../../../store/general/types';
import { PhraseDetailsPanelSelectors } from '../../selectors';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState,
		props: IPhrasePopupHOCProps,
	): IPhrasePopupFields => {
		const { type } = props;

		const phrasePopup = PhraseListSelectors.getPhrasePopup(state);
		const isShow = phrasePopup && phrasePopup === type &&
			getMainLayoutPhrasesColumn(state) === EPhrasesColumnType.COLUMNS_1 &&
			!!PhraseDetailsPanelSelectors.getText(state);

		return {
			isShow,
		}
	};
}

const mapDispatchToProps = (
	dispatch: any
): IPhrasePopupEvents => {
	return {
		onClose: () => dispatch(PhrasePopupEvents.onClose()),
	}
}

export const PhrasePopupHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(PhrasePopup) as any;

PhrasePopupHOC.displayName = 'PhrasePopupHOC';
